module.exports = __webpack_public_path__ + "static/media/logo-greater_good.e8fffdca.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/articles/logo-greater_good.png
// module id = 232
// module chunks = 0